import { Controller } from '@hotwired/stimulus';

function getWrapper(element) {
  return element.closest('[data-dynamic-form-wrapper-id]');
}

function getWrapperId(element) {
  return getWrapper(element)?.dataset.dynamicFormWrapperId;
}

export default class extends Controller {
  static values = { fields: Array, action: String };
  waitingForBlur = false;

  connect() {
    this.element.addEventListener('turbo:submit-start', this.onSubmitStart);
    this.element.addEventListener('change', this.onChange);
    this.element.addEventListener('turbo:before-frame-render', this.onBeforeFrameRender);

    this.onChange();
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.onSubmitStart);
    this.element.removeEventListener('change', this.onChange);
    this.element.removeEventListener('turbo:before-frame-render', this.onBeforeFrameRender);
  }

  onSubmitStart = (e) => {
    const { formSubmission } = e.detail;
    if (formSubmission.method !== 'get') return;
    if (formSubmission.submitter !== this.submitValidate) return;

    const { searchParams } = formSubmission.fetchRequest.url;

    const allowedKeys = this.fieldsValue;

    Array.from(searchParams.keys()).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        searchParams.delete(key);
      }
    });
  };

  onBeforeFrameRender = (e) => {
    const formElements = 'input, textarea, xfive-date-picker, select, [data-dynamic-form-preserve]';

    Array.from(e.detail.newFrame.querySelectorAll(formElements)).forEach((el) => {
      if (!el.id) return;
      const oldEl = e.target.querySelector(`#${el.id}`);
      if (!oldEl) return;

      const wrapperId = getWrapperId(el);
      const oldWrapperId = getWrapperId(oldEl);

      if (wrapperId !== oldWrapperId) {
        const resetOnNotMatchingWrapperId =
          getWrapper(el)?.dataset.dynamicFormResetOnNotMatchingWrapperId === '';

        if (resetOnNotMatchingWrapperId) {
          // supports only some fields, expand if needed

          if (el.tagName === 'XFIVE-DATE-PICKER') {
            el.setAttribute('value', '');
          }
        }

        return;
      }

      if (el.dataset.dynamicFormPreserve === '') {
        el.replaceWith(oldEl);
      } else if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = oldEl.checked;
      } else if (el.type === 'file') {
        el.files = oldEl.files;
      } else {
        el.value = oldEl.value;
      }
    });
  };

  onChange = async (e) => {
    const list = this.fieldsValue.map((field) => this.element.elements[field]?.value);
    const listStr = list.join('::');

    if (this.comparableValues === undefined) {
      this.comparableValues = listStr;
      return;
    } else if (this.comparableValues === listStr) {
      return;
    }

    this.comparableValues = listStr;

    if (!this.submitValidate) {
      const button = document.createElement('button');
      button.type = 'submit';
      button.hidden = true;
      button.formMethod = 'get';
      button.formAction = this.actionValue;
      button.dataset.turboFrame = this.element.querySelector('turbo-frame').id;
      this.element.appendChild(button);
      this.submitValidate = button;
    }

    if (this.waitingForBlur) return;

    if (document.activeElement.tagName === 'XFIVE-DATE-PICKER') {
      this.waitingForBlur = true;
      await new Promise((resolve) =>
        document.activeElement.addEventListener('blur', resolve, { once: true }),
      );
      this.waitingForBlur = false;
    }

    this.submitValidate.click();

    if (!e.isTrusted) {
      this.submitValidate.click();
    }
  };
}
